module.exports = __webpack_public_path__ + "static/media/curvedArrow.fe0aed9f.svg";